<!--suppress ALL -->
<template>
    <td :data-label="label" :class="position ? `has-text-${position}` : ''">
        <slot></slot>
    </td>
</template>

<script lang="ts">
	import {Component, Vue, Prop} from 'annotation';

	@Component
	export default class GTableColumn extends Vue {

		@Prop()
		public label: string;

		@Prop()
		public position: string;
	}
</script>
